import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseAbsence: React.FC<BaseIconProps> = ({size, color}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM21 12C21 16.9706 16.9706 21 12 21C9.78472 21 7.75638 20.1996 6.18837 18.8723L18.8723 6.18837C20.1996 7.75638 21 9.78472 21 12ZM17.8116 5.12771C16.2436 3.80037 14.2153 3 12 3C7.02944 3 3 7.02944 3 12C3 14.2153 3.80037 16.2436 5.12771 17.8116L17.8116 5.12771Z"
        fill={color}
      />
    </svg>
  );
};
